import React from "react";

const SocialShare = [
  {
    iconName: "fa fa-github",
    link: "https://github.com/bilalhassan97",
  },
  { iconName: "fa fa-linkedin", link: "https://pk.linkedin.com/in/bilal-hassan-360825142" },
];

const Social = () => {
  return (
    <ul className="social list-unstyled pt-1 mb-5">
      {SocialShare.map((val, i) => (
        <li key={i}>
          <a href={val.link} target="_blank" rel="noreferrer">
            <i className={val.iconName}></i>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Social;
